/* global dataLayer */

import 'dayjs/locale/sv';
import './Educations.scss';

import React, { Fragment } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import dayjs from 'dayjs';

class Educations extends React.Component {
    state = {
        activeCategory: false,
        sortBy: '',
        desc: false,
    };

    componentDidMount() {
        const hash = window.location.hash.substr(1);
        if (!hash) {
            return;
        }
        const { educationCategories } = this.props;
        const category = educationCategories.find((item) => item.slug === hash);
        this.setState({
            activeCategory: category.id
        });
    }

    sortCourses = (courses) => {
        return courses.sort((a, b) => {
            if (a.start === '' && b.start !== '') {
                return 1;
            }

            if (a.start !== '' && b.start === '') {
                return -1;
            }

            if (a.start < b.start) {
                return -1;
            }

            if (a.start > b.start) {
                return 1;
            }

            return 0;
        });
    }

    getCourseCities = (courses) => {
        return this.sortCourses(courses).map((item, index) => {
            if (item.city) {
                return (<p key={index}>{item.city}</p>);
            }
        });
    }

    getCourseCitiesNoCourse = (item) => {
        if (item.city) {
            return (<p>{item.city}</p>);
        }
    }

    getCourseDates = (courses) => {
        return this.sortCourses(courses).map((item, index) => {
            if (dayjs(item.start).isValid()) {
                return (<p key={index}>{dayjs(item.start).locale('sv').format('D MMMM YYYY')}</p>);
            }
        });
    }

    getNextCourse = (courses) => {
        if (!courses) {
            return {};
        }

        if (Object.keys(courses).length < 2) {
            return courses[0];
        }

        return courses
            .sort((a, b) => a.start > b.start)[0];
    }

    changeSortvalue = (value) => {
        this.setState((prevState) => ({
            desc: value !== prevState.sortBy ? false : !prevState.desc,
            sortBy: value,
        }));
    };

    handlePushDataLayer = (e) => {
        let value = e.currentTarget.dataset.title;
        value = value.replace('&#8211;', '-');

        dataLayer.push({
            'event': 'clickEducationListItem',
            'educationTitle': value
        });
    }

    compare = (a, b) => {
        if (a < b) {
            return -1;
        } else if (a > b) {
            return 1;
        }

        return 0;
    };

    setActiveCategory = (e) => {
        const category = JSON.parse(e.currentTarget.dataset.category);

        this.setState(({
            activeCategory: category.id
        }), () => {
            if (category) {
                window.location.hash = category.slug;
            } else {
                window.location.hash = '';
            }
        });

        dataLayer.push({
            'event': 'educationFilterClick'
        });
    }

    render() {
        const { educations, educationCategories } = this.props;
        const { activeCategory, sortBy, desc } = this.state;

        const filteredEducations = educations.filter((education) => {

            if (!activeCategory) {
                return true;
            }
            return education.categories.includes(activeCategory);
        });

        const sortedEducations = filteredEducations.sort((a, b) => {
            if (sortBy === 'title') {
                return this.compare(
                    a.title.rendered,
                    b.title.rendered
                );
            } else if (sortBy === 'city') {
                return this.compare(
                    this.getNextCourse(a.educationCourses).city,
                    this.getNextCourse(b.educationCourses).city
                );
            } else if (sortBy === 'start') {
                return this.compare(
                    this.getNextCourse(a.educationCourses).start,
                    this.getNextCourse(b.educationCourses).start
                );
            } else {
                return this.compare(a[sortBy], b[sortBy]);
            }
        });

        if (desc) {
            sortedEducations.reverse();
        }

        return (
            <div className="Educations">
                <div className="button-list">
                    <button
                        className={classNames('button-list__item', {
                            'button-list__item--active': !activeCategory,
                        })}
                        data-category="false"
                        onClick={this.setActiveCategory}
                    >
                        Alla
                    </button>
                    {educationCategories.map((item, index) => (
                        <button
                            className={classNames('button-list__item', {
                                'button-list__item--active':
                                    activeCategory === item.id,
                            })}
                            data-category={JSON.stringify(item)}
                            onClick={this.setActiveCategory}
                            key={index}>
                            {item.name}
                        </button>
                    ))}
                    <select
                        className="Educations__SortSelect"
                        onChange={
                            (e) => this.changeSortvalue(e.target.value)
                        }>
                        <option value="">Sortera</option>
                        <option value="title">Namn</option>
                        <option value="city">Ort</option>
                        <option value="start">Nästa tillfälle</option>
                    </select>
                </div>
                <div className="Educations__List">
                    <div className="Educations__ListHeader">
                        <span
                            className={classNames('Educations__ListLabel', {
                                'Educations__ListLabel--Desc': desc && sortBy === 'title',
                                'Educations__ListLabel--Asc': !desc && sortBy === 'title'
                            })}
                            data-sort="title"
                            onClick={(e) =>
                                this.changeSortvalue(
                                    e.currentTarget.dataset['sort']
                                )
                            }>
                            Namn
                        </span>
                        <span className="Educations__ListLabel Educations__ListLabel--NoSort">Utbildningens längd</span>
                        <span
                            className={classNames('Educations__ListLabel', {
                                'Educations__ListLabel--Desc': desc && sortBy === 'city',
                                'Educations__ListLabel--Asc': !desc && sortBy === 'city'
                            })}
                            data-sort="city"
                            onClick={(e) =>
                                this.changeSortvalue(
                                    e.currentTarget.dataset['sort']
                                )
                            }>
                            Ort
                        </span>
                        <span
                            className={classNames('Educations__ListLabel', {
                                'Educations__ListLabel--Desc': desc && sortBy === 'start',
                                'Educations__ListLabel--Asc': !desc && sortBy === 'start'
                            })}
                            data-sort="start"
                            onClick={(e) =>
                                this.changeSortvalue(
                                    e.currentTarget.dataset['sort']
                                )
                            }>
                            Nästa tillfälle
                        </span>
                        <span className="Educations__ListLabel Educations__ListLabel--NoSort">Avgift</span>
                    </div>
                    {sortedEducations.map((item) => (
                        <a
                            className="Educations__ListItem"
                            key={item.id}
                            data-id={item.id}
                            data-title={item.title.rendered}
                            href={item.link}
                            onClick={this.handlePushDataLayer}
                        >
                            <span className="Educations__ListItemCell">
                                <h2
                                    className="Educations__ListItemTitle"
                                    dangerouslySetInnerHTML={{ __html: item.title.rendered }}
                                />
                                {item.education_description && (
                                    <p className="Educations__ListItemDescription">
                                        {item.education_description}
                                    </p>
                                )}
                            </span>
                            <span className="Educations__ListItemCell">
                                <span className="Educations__ListItemLabel">
                                Utbildningens längd:
                                </span>
                                {item.education_course_length}
                            </span>
                            <span className="Educations__ListItemCell">
                                {item.education_courses && (
                                    <Fragment>
                                        <span className="Educations__ListItemLabel">
                                            Ort:
                                        </span>
                                        {
                                            this.getCourseCities(item.education_courses)
                                        }
                                    </Fragment>
                                )}
                                {!item.education_courses && (
                                    <Fragment>
                                        <span className="Educations__ListItemLabel">
                                            Ort:
                                        </span>
                                        {
                                            this.getCourseCitiesNoCourse(item)
                                        }
                                    </Fragment>
                                )}
                            </span>
                            <span className="Educations__ListItemCell">
                                {item.education_courses && (
                                    <Fragment>
                                        <span className="Educations__ListItemLabel">
                                            Nästa tillfälle:
                                        </span>
                                        {
                                            this.getCourseDates(item.education_courses)
                                        }
                                    </Fragment>
                                )}
                            </span>
                            <span className="Educations__ListItemCell">
                                <span className="Educations__ListItemLabel">
                                    Pris:
                                </span>
                                {item.education_entry_fee}
                            </span>
                        </a>
                    ))}
                </div>
            </div>
        );
    }
}

Educations.propTypes = {
    educations: PropTypes.array,
    educationCategories: PropTypes.array,
};

Educations.defaultProps = {
    educations: [],
    educationCategories: [],
};

export default Educations;
